<template>
    <div :class="{'mb-10': !noMargin}">
        <div class="font-weight-bold"
             :class="{'text-warning':warning}"
             :title="title"
        >
            <i v-if="warning" class="fas fa-exclamation-triangle text-warning" />
            {{ label }}
            <!--            <span v-if="required">*</span>-->
        </div>
        <div class="d-flex flex-row align-items-center mt-n1 mb-2">
            <div v-if="!required" class="font-weight-bold form-text text-muted mr-1">
                {{ __('general.optional').toUpperCase() }}
            </div>
            <span v-if="description"
                  class="form-text text-muted"
                  style="white-space: pre-line;"
                  v-text="description"
            />
            <span v-else-if="!required" class="form-text text-muted">
                {{ __('form.you_may_leave_unchanged') }}
            </span>
        </div>
        <slot/>
        <FormErrors v-if="error" :error="error"/>
    </div>
</template>

<script>
import FormErrors from "@components/Form/FormErrors.vue";
import Badge from "@components/Badge.vue";

export default {
    components: {
        Badge,
        FormErrors
    },

    props: {
        label: {
            type: String,
            required: true
        },
        description: String,
        error: String,
        required: Boolean,
        warning: Boolean,
        noMargin: Boolean
    },

    computed: {
        title() {
            if (this.required) {
                return __('form.required_input')
            }

            return __('form.optional_input')
        }
    }
}
</script>
